import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
// Indispensable pour transformer le JSX en string
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';

// Ou ton import d'icône
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MapPin } from 'lucide-react';

// 1. Création de l'icône personnalisée avec ton composant React
const customIcon = L.divIcon({
  html: renderToStaticMarkup(<MapPin className='w-8 h-8 text-blue-500 fill-blue-100' />),
  className: 'custom-leaflet-icon', // On retire les styles par défaut de Leaflet
  iconSize: [32, 32],
  iconAnchor: [16, 32], // Centre le bas du pin sur les coordonnées
});

interface MapProps {
  isDarkMode?: boolean;
  lat?: number;
  lng?: number;
}

export const LeafletMap: React.FC<MapProps> = ({ isDarkMode = false, lat = 48.8566, lng = 2.3522 }) => {
  const apiKey = import.meta.env.VITE_CARTO_API_KEY?.trim();
  if (!apiKey) {
    return (
      <div role='status' className='flex h-[400px] items-center justify-center rounded-lg bg-gray-100 text-gray-600'>
        Carte indisponible pour le moment.
      </div>
    );
  }
  const style = isDarkMode ? 'dark_all' : 'voyager';
  const tileUrl = `https://basemaps.cartocdn.com/rastertiles/${style}/{z}/{x}/{y}{r}.png?key=${encodeURIComponent(apiKey)}`;

  return (
    <div style={{ height: '400px', width: '100%', borderRadius: '8px', overflow: 'hidden', zIndex: '20' }}>
      <MapContainer
        center={[lat, lng]}
        zoom={13}
        scrollWheelZoom={false}
        style={{ height: '100%', width: '100%' }}
        key={`${lat}-${lng}`}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
          url={tileUrl}
        />

        {/* 2. On passe l'icône ici */}
        <Marker position={[lat, lng]} icon={customIcon}>
          <Popup>C'est ici !</Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};
